import React, { useState, useContext } from 'react';
import { ThemeContext } from '../../context/ThemeContext';
import { motion } from 'framer-motion';

const markets = {
  Commodities: [
    { symbol: 'TVC:GOLD', name: 'Gold' },
    { symbol: 'TVC:SILVER', name: 'Silver' },
    { symbol: 'TVC:USOIL', name: 'Crude Oil' },
    { symbol: 'ICEUS:CC1!', name: 'Cocoa' }
  ],
  Forex: [
    { symbol: 'FX:EURUSD', name: 'EUR/USD' },
    { symbol: 'FX:GBPUSD', name: 'GBP/USD' },
    { symbol: 'FX:USDJPY', name: 'USD/JPY' }
  ],
  Indices: [
    { symbol: 'SP:SPX', name: 'S&P 500' },
    { symbol: 'NDX', name: 'Nasdaq 100' },
    { symbol: 'DJI', name: 'Dow Jones' }
  ],
  Crypto: [
    { symbol: 'BINANCE:BTCUSD', name: 'Bitcoin' },
    { symbol: 'BINANCE:ETHUSD', name: 'Ethereum' },
    { symbol: 'BINANCE:SOLUSD', name: 'Solana' }
  ]
};

const MarketChart = () => {
  const { theme } = useContext(ThemeContext);
  const [activeTab, setActiveTab] = useState('Commodities');
  const [activeSymbol, setActiveSymbol] = useState('TVC:GOLD');

  return (
    <section style={{ padding: '6rem 5%', background: 'var(--bg-secondary)', borderTop: '1px solid var(--border-color)' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h2 style={{ fontSize: '2.5rem', fontWeight: '800', marginBottom: '1rem', letterSpacing: '-0.02em' }}>Live Market Data</h2>
          <p style={{ color: 'var(--text-secondary)', maxWidth: '600px', margin: '0 auto', fontSize: '1.1rem' }}>
            Monitor global markets in real-time. Our algorithmic strategies actively trade across all major asset classes.
          </p>
        </div>

        <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', marginBottom: '2rem', flexWrap: 'wrap' }}>
          {Object.keys(markets).map((tab) => (
            <button
              key={tab}
              onClick={() => {
                setActiveTab(tab);
                setActiveSymbol(markets[tab][0].symbol);
              }}
              style={{
                padding: '0.8rem 2rem', borderRadius: '30px', fontWeight: '700', cursor: 'pointer',
                background: activeTab === tab ? 'var(--text-primary)' : 'transparent',
                color: activeTab === tab ? 'var(--bg-primary)' : 'var(--text-primary)',
                border: activeTab === tab ? 'none' : '1px solid var(--border-color)',
                transition: 'all 0.2s'
              }}
            >
              {tab}
            </button>
          ))}
        </div>

        <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1.5rem', overflowX: 'auto', paddingBottom: '0.5rem' }}>
          {markets[activeTab].map((pair) => (
            <button
              key={pair.symbol}
              onClick={() => setActiveSymbol(pair.symbol)}
              style={{
                padding: '0.5rem 1.5rem', borderRadius: '8px', fontWeight: '600', cursor: 'pointer', whiteSpace: 'nowrap',
                background: activeSymbol === pair.symbol ? 'var(--accent-gradient)' : 'var(--bg-primary)',
                color: activeSymbol === pair.symbol ? '#000' : 'var(--text-secondary)',
                border: activeSymbol === pair.symbol ? 'none' : '1px solid var(--border-color)',
                boxShadow: activeSymbol === pair.symbol ? '0 4px 15px rgba(252, 213, 53, 0.2)' : 'none'
              }}
            >
              {pair.name}
            </button>
          ))}
        </div>

        <motion.div 
          key={activeSymbol}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          style={{ height: '500px', borderRadius: '16px', overflow: 'hidden', border: '1px solid var(--border-color)', boxShadow: '0 20px 40px rgba(0,0,0,0.1)' }}
        >
          <iframe
            src={`https://s.tradingview.com/widgetembed/?frameElementId=tradingview_1&symbol=${encodeURIComponent(activeSymbol)}&interval=D&symboledit=1&saveimage=1&toolbarbg=f1f3f6&studies=%5B%5D&theme=${theme}&style=1&timezone=Etc%2FUTC&studies_overrides=%7B%7D&overrides=%7B%7D&enabled_features=%5B%5D&disabled_features=%5B%5D&locale=en&utm_source=&utm_medium=widget&utm_campaign=chart`}
            width="100%"
            height="100%"
            frameBorder="0" 
            allowtransparency="true" 
            allowFullScreen={true}
            scrolling="no"
            title={`crypto-chart-${activeSymbol}`}
            style={{ display: 'block' }}
          />
        </motion.div>
      </div>
    </section>
  );
};

export default MarketChart;
